import classNames from "classnames";
import { useCallback } from "react";
import { useDrop } from "react-dnd";
import { defineMessages } from "react-intl";

import { useSortableListInputContext } from ".";
import { useFormatMessage } from "../../Intl/Context";
import SortableListDraggableSource, {
  SORTABLE_DRAGGABLE_LIST_SOURCE
} from "./SortableListDraggableSource";

const SortableListOptionsZone = () => {
  const { options, moveOptions, addItemToOptions } = useSortableListInputContext();

  const t = useFormatMessage();
  const noOptionsLabel = t(intlMessages.noOptions);

  const noOptionsToSort = options.length === 0;

  const handleOptionDropped = useCallback(
    droppedItem => {
      if (!droppedItem.isSelected) return;

      addItemToOptions(droppedItem);
    },
    [addItemToOptions]
  );

  const [{ hasNewItemOver }, droppableRef] = useDrop(
    () => ({
      accept: SORTABLE_DRAGGABLE_LIST_SOURCE,
      drop: handleOptionDropped,
      collect: monitor => {
        const draggedItem = monitor.getItem();

        const hasNewItemOver =
          draggedItem && draggedItem.isSelected && monitor.isOver({ shallow: true });

        return { hasNewItemOver };
      }
    }),
    [options, handleOptionDropped]
  );

  const className = classNames("sortable-list-options-list padding-x-xxs", {
    "has-new-item-over": hasNewItemOver,
    "d-flex": noOptionsToSort,
    "align-items-center": noOptionsToSort,
    "justify-content-center": noOptionsToSort,
    "text-center": noOptionsToSort
  });

  return (
    <div className={className} ref={droppableRef}>
      {noOptionsToSort && (
        <p className="padding-xs text-muted font-italic">{noOptionsLabel}</p>
      )}

      {options.map(option => (
        <SortableListDraggableSource
          key={option.id}
          option={option}
          moveOptions={moveOptions}
          addItemToOptions={addItemToOptions}
          showPosition={false}
        />
      ))}
    </div>
  );
};

export default SortableListOptionsZone;

const intlMessages = defineMessages({
  noOptions: {
    id: "inputs.sortableList.optionsZone.noOptions",
    defaultMessage: "Aucune option à prioriser"
  }
});
